module.exports = "img/flags/SG.97e190b.png";